import { MdClose } from "react-icons/md";
import { FieldWrappers } from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import { useState } from "react";

const MultiEmailInput = ({ value = [], onChange, placeholder }) => {
    const [draft, setDraft] = useState("");

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const commitDraft = () => {
        const text = draft.trim().replace(/[,;]$/, "");
        if (!text) return;

        const parts = text
            .split(/[,;\s]+/)
            .map((e) => e.trim())
            .filter(Boolean);

        const valid = parts.filter((e) => EMAIL_REGEX.test(e));
        const merged = [...value];
        valid.forEach((e) => {
            if (!merged.includes(e)) merged.push(e);
        });
        onChange(merged);
        setDraft("");
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === "," || e.key === ";") {
            e.preventDefault();
            commitDraft();
        } 
        // else if (e.key === "Backspace" && !draft && value.length > 0) {
        //     onChange(value.slice(0, -1));
        // }
    };

    const handleRemove = (email) => {
        onChange(value.filter((e) => e !== email));
    };

    return (
        <div className="space-y-2">
            {/* Input (your FieldWrappers style) */}
            <FieldWrappers>
                <input
                    type="text"
                    value={draft}
                    placeholder={placeholder}
                    onChange={(e) => setDraft(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={commitDraft}
                    className="w-full border-none outline-none bg-transparent"
                />
            </FieldWrappers>

            {/* Chips row (below input) */}
            {value.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                    {value.map((email) => (
                        <EmailChip key={email}>
                            <span className="truncate max-w-[160px]">
                                {email}
                            </span>
                            <button
                                type="button"
                                onClick={() => handleRemove(email)}
                                className="text-gray-500 hover:text-red-500 transition-colors flex-shrink-0"
                                aria-label={`Remove ${email}`}
                            >
                                <MdClose size={12} />
                            </button>
                        </EmailChip>
                    ))}
                </div>
            )}
        </div>
    );
};

const EmailChip = tw.span`
    inline-flex items-center gap-1
    text-xs font-medium text-gray-700
    bg-gray-100 rounded-md
    px-2 py-1
`;

export default MultiEmailInput;